"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _FeedbackResponseState = require("../store/FeedbackResponseState");
var _FeedbackQuestionsState = require("../store/FeedbackQuestionsState");
var _UIState = require("../store/UIState");
var _FeedbackConstants = require("../constants/FeedbackConstants");
var _FeedbackForm = _interopRequireDefault(require("../components/FeedbackForm"));
/**
 * This will be the entry point of the feedback service for host applications.
 * @param {string} intent - Intent of feedback, can be general or triggered. This is a required prop
 * @param {string} title - represents the title of the feedback form. Default value will be used if not provided as prop
 * @param {string} confirmationMessage - represents the confirmation message of feedback submission. Default value will be used if not provided as prop
 * @param {string} submitButtonSize - represents the size of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} submitButtonType - represents the type of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} submitButtonText - represents the text of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} applicationId - The application Id where the feedback module is integrated
 * @param {string} feedbackSubmissionPageIdentifier - The identifier of the page from which feedback was submitted
 * @param {string} displayMode - flag to control darkMode.
 * @param {{ isTriggered: boolean, resetTrigger: () => any }} triggeredObj - Triggered object containing details about when feedback is triggered from outside and how to handle reset
 *
 * @returns - FeedbackForm containing the questionnaire provided and its type will be according to the intent passed.
 */
var Feedback = function Feedback(_ref) {
  var feedbackIntent = _ref.feedbackIntent,
    title = _ref.title,
    description = _ref.description,
    confirmationMessage = _ref.confirmationMessage,
    submitButtonSize = _ref.submitButtonSize,
    submitButtonType = _ref.submitButtonType,
    submitButtonText = _ref.submitButtonText,
    applicationId = _ref.applicationId,
    feedbackSubmissionPageIdentifier = _ref.feedbackSubmissionPageIdentifier,
    triggeredObj = _ref.triggeredObj,
    userId = _ref.userId,
    isSkippable = _ref.isSkippable,
    prePopulate = _ref.prePopulate,
    displayMode = _ref.displayMode;
  return /*#__PURE__*/_react["default"].createElement(_FeedbackQuestionsState.FeedbackQuestionsState, {
    feedbackIntent: feedbackIntent,
    applicationId: applicationId
  }, /*#__PURE__*/_react["default"].createElement(_FeedbackResponseState.FeedbackResponseState, null, /*#__PURE__*/_react["default"].createElement(_UIState.UIState, null, /*#__PURE__*/_react["default"].createElement(_FeedbackForm["default"], {
    title: title,
    feedbackIntent: feedbackIntent,
    description: description,
    confirmationMessage: confirmationMessage,
    submitButtonSize: submitButtonSize,
    submitButtonType: submitButtonType,
    submitButtonText: submitButtonText,
    applicationId: applicationId,
    feedbackSubmissionPageIdentifier: feedbackSubmissionPageIdentifier,
    triggeredObj: triggeredObj,
    userId: userId,
    isSkippable: isSkippable,
    prePopulate: prePopulate,
    displayMode: displayMode
  }))));
};
Feedback.propTypes = {
  feedbackIntent: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  confirmationMessage: _propTypes["default"].string,
  submitButtonSize: _propTypes["default"].string,
  submitButtonType: _propTypes["default"].string,
  submitButtonText: _propTypes["default"].string,
  applicationId: _propTypes["default"].string.isRequired,
  feedbackSubmissionPageIdentifier: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  triggeredObj: _propTypes["default"].shape({
    isTriggered: _propTypes["default"].bool.isRequired,
    resetTrigger: _propTypes["default"].func.isRequired
  }),
  userId: _propTypes["default"].string,
  isSkippable: _propTypes["default"].bool,
  prePopulate: _propTypes["default"].object
};
Feedback.defaultProps = {
  title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
  description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
  confirmationMessage: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.confirmationMessage,
  submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
  feedbackSubmissionPageIdentifier: null,
  triggeredObj: {
    isTriggered: false,
    resetTrigger: _noop["default"]
  },
  userId: null,
  isSkippable: true,
  prePopulate: {}
};
var _default = exports["default"] = Feedback;
//# sourceMappingURL=Feedback.js.map